import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import * as $ from 'jquery';
import {PromocionesListComponent} from './promociones-list.component';
import {PromocionesService} from './promociones.service';
import {IPromocion} from './promocion';
import * as myGlobals from './../global';
import {HttpErrorValidator} from '../services/http-error-validator';
import {Observable} from 'rxjs';
import {IIssuer} from '../ruteo/issuer';
import {RuteosService} from '../ruteo/ruteos.service';
import {IPos} from '../pos/pos';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-promociones',
  templateUrl: './promociones.component.html',
  styleUrls: ['./promociones.component.sass']
})
export class PromocionesComponent implements OnInit, OnDestroy, AfterViewInit {
  errorMessage = '';
  currentPg = 1;

  selectedCardIssuerValue = localStorage.getItem('promotionsSelectedCardIssuerId') != null
    ? localStorage.getItem('promotionsSelectedCardIssuerId') : '';

  cardIssuerList: Observable<IIssuer[]> = this.routingService.getIssuers();

  promociones: IPromocion[] = [];
  filteredPromociones: IPromocion[] = [];

  constructor(
    public service: PromocionesService,
    private parent: PromocionesListComponent,
    private httpErrorValidator: HttpErrorValidator,
    private routingService: RuteosService
  ) {
  }

  ngAfterViewInit() {
    $('a[rel=promociones]').addClass('selected');
  }

  newPromocion(): void {
    this.parent.showEditPromocion = false;
    this.parent.showPromociones = false;
    this.parent.showAddPromocion = true;
  }

  ngOnInit(): void {
    this.queryPromotions();
  }

  queryPromotions(): void {
    this.service.getPromociones().subscribe(
      promociones => {
        this.promociones = promociones;
        this.filteredPromociones = this.filterPromotions();
      },
      error => {
        this.httpErrorValidator.validateError(error);
        this.errorMessage = error as any;
      }
    );
  }

  filterPromotions() {
    return this.promociones.filter(
      promocion => this.applyFilterOverPromotion(promocion)
    );
  }

  applyFilterOverPromotion(promotion: IPromocion) {
    console.log('selectedCardIssuer:' + this.selectedCardIssuerValue);
    console.log('promotionCardIssuerEvaluated:' + promotion.cardIssuerId);


    if (this.selectedCardIssuerValue !== '') {
      console.log('filter selected');
      if (('' + promotion.cardIssuerId) !== this.selectedCardIssuerValue) {
        return false;
      }
    }

    return true;
  }

  get searchCardIssuer(): string {
    return this.selectedCardIssuerValue;
  }

  set searchCardIssuer(value: string) {
    this.selectedCardIssuerValue = value;
    localStorage.setItem('promotionsSelectedCardIssuerId', value);
    this.filteredPromociones = this.filterPromotions();
  }

  edit(elemento, index: number) {
    this.parent.editnumber = elemento.filteredPromociones[index].id;
    this.parent.showPromociones = false;
    this.parent.showAddPromocion = false;
    this.parent.showEditPromocion = true;
  }

  delete(elemento, index: number) {
    const self = this;
    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/promotion/' + elemento.filteredPromociones[index].id,
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      }
      ,
      type: 'DELETE'
    }).done(function () {
      console.log('delete sucess!!');
      self.queryPromotions();
    }).fail(function(jqXHR) {
      alert('No se pudo eliminar la promocion: ' + errorMessageFromAjax(jqXHR));
    });
  }

  ngOnDestroy() {
    $('a[rel=promociones]').removeClass('selected');
  }
}
